import React, { useEffect, useState } from "react";
import api from "../../../../api"; // adjust path if needed

const Topper = () => {
  const [toppers, setToppers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchToppers = async () => {
      try {
        const response = await api.get("/api/sitepages/alumni/topper");
        const data = response.data;

        // Ensure topper_section exists
        if (data && data.topper_section) {
          const section = data.topper_section;

          // Normalize arrays
          const titles = Array.isArray(section.topper_title)
            ? section.topper_title
            : [section.topper_title];

          const contents = Array.isArray(section.topper_content)
            ? section.topper_content
            : [section.topper_content];

          const videos = Array.isArray(section.topper_video)
            ? section.topper_video
            : [section.topper_video];

          // Merge them together
          const merged = titles.map((title, index) => ({
            topper_title: title,
            topper_content: contents[index] || "",
            topper_video: videos[index] || "",
          }));

          setToppers(merged);
        }
      } catch (error) {
        console.error("Error fetching topper data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchToppers();
  }, []);

  if (loading) return <></>;
  if (toppers.length === 0) return <></>;

  return (
    <section className="topper mt-5 mb-5 pb-5 pt_80">
      <div className="container">
        {toppers.map((topper, index) => (
          <div className="row align-items-center mb-5" key={index}>
            {/* Video Column */}
            <div className={`col-md-6 col-lg-6 col-12 ${index == toppers.length ? 'mb-5' : ''}`}>
              <div
                className="content-video "


              >
                {topper.topper_video ? (
                  <iframe
                    width="560"
                    height="315"
                    src={topper.topper_video}
                    title={`Topper Video ${index + 1}`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                  ></iframe>
                ) : (
                  <p>No video available</p>
                )}
              </div>
            </div>

            {/* Text Column */}
            <div className="col-md-6 col-lg-6 col-12">
              <div className="alumni_side">
                <h3

                  dangerouslySetInnerHTML={{
                    __html: topper.topper_title || "Untitled",
                  }}
                />
              </div>
              <p
                className="para "

                dangerouslySetInnerHTML={{
                  __html:
                    topper.topper_content ||
                    "No description available for this topper.",
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Topper;